import $ from 'jquery';

const toggleCountries = (el) => {
    const $el = $(el);
    $el.click((e) => {
        e.preventDefault();
        $el.next().slideToggle(250);
        $el.toggleClass('js-state-active');
    });

    $(document).mouseup((e) => {
        if($el.hasClass('js-state-active') && !$el.is(e.target) && $el.has(e.target).length === 0) {
            $el.next().slideUp(250);
            $el.removeClass('js-state-active');
        }
    });
};

export default toggleCountries;
